module.exports = __webpack_public_path__ + "img/icon-letter.d0b20997.svg";